.main {
  background-color: var(--mh-page-bg, #f8fafc);
  /*
   * body/#root are overflow:hidden. Mantine Main defaults to min-height:100dvh and grows
   * with content, so long pages are clipped with no scrollbar.
   *
   * Lock Main to the viewport (border-box includes Mantine header/navbar padding offsets).
   * Scroll lives on .mainInner so every page scrolls without relying on PageShell flex chains.
   */
  box-sizing: border-box !important;
  height: 100dvh !important;
  max-height: 100dvh !important;
  min-height: 0 !important;
  overflow: hidden !important;
  display: flex !important;
  flex-direction: column !important;
}

.mainInner {
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
  max-width: 100%;
  padding: 28px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  /* Primary page scrollport — works even if a page forgets PageShell layout=scroll */
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
}

/* Workspace pages fill the viewport; nested panels own scroll (no page-level bar). */
.mainInner:has([data-layout='workspace']) {
  overflow: hidden;
}

@media (max-width: 48em) {
  .mainInner {
    padding: 16px;
  }
}

.header {
  border-bottom: 1px solid var(--mantine-color-gray-2);
  background: #fff;
}
